import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import moment from "moment/moment";
import { CardContainer } from "../Container/CardContainer";
import { IconEyeFilled } from "@tabler/icons-react";
import { IconAwardFilled } from "@tabler/icons-react";
import MetricStatus from "../MetricStatus/MetricStatus";

export const CardPostMetric = ({
	thread,
	date,
	rd = 8,
	borderType = "full",
	size = "lg",
	isRemarkable = false,
	isRanked = false,
	rank = 0,
}) => {
	const theme = useTheme();
	
	return (
		<CardContainer w={"100%"} rd={rd} borderType={borderType}>
			<Box
				sx={{
					padding: theme.spacing(1.5, 2),
					width: "100%",
					backgroundColor: theme.palette.background.paper,
					display: "flex",
					flexDirection: "column",
					gap: theme.spacing(2),
					borderRadius: theme.spacing(0.5),
				}}
			>
				<Stack spacing={0.5}>
					<Stack direction="row" alignItems="center" spacing={0} sx={{ height: 20 }}>
						{isRanked && (
							<Box
								sx={{
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									width: 16,
									height: 16,
									borderRadius: "50%",
									backgroundColor: theme.palette.text.primary,
								}}
							>
								<Typography
									variant="body2"
									sx={{
										fontWeight: 700,
										lineHeight: 1,
										color: theme.palette.background.paper,
										fontSize: "0.875rem",
									}}
								>
									{rank}
								</Typography>
							</Box>
						)}
						<Stack direction="row" spacing={0.25} alignItems="center" sx={{ color: theme.palette.text.secondary }}>
							{thread.viewRank < 4 && (
								<IconEyeFilled color={theme.palette.primary.main} size={18} />
							)}
							{(thread.engagementRank < 4 || isRemarkable === true) && (
								<IconAwardFilled
									color={theme.palette.text.primary}
									size={18}
									style={{ marginRight: "-8px" }}
								/>
							)}
						</Stack>
					</Stack>
					<Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 0.5 }}>
						<Typography
							variant="body1"
							sx={{
								fontWeight: 500,
								lineHeight: 1,
								color: theme.palette.text.secondary,
							}}
						>
							{moment(date).format("MM/DD")}
						</Typography>
						<Typography
							variant="body1"
							sx={{
								fontWeight: 500,
								lineHeight: 1,
								color: theme.palette.text.secondary,
							}}
						>
							{moment(date).format("ddd")}
						</Typography>
					</Stack>
					<a href={thread.permalink} target="_blank" rel="noreferrer">
						<Typography
							sx={{
								fontFamily: '"source-han-serif-korean", "Noto Serif KR", "Noto Serif CJK KR", "Source Han Serif KR", "Apple SD Gothic Neo", "Malgun Gothic", "맑은 고딕", serif',
								lineHeight: 1.55,
								fontSize: "1rem",
								height: 48,
								fontWeight: 900,
								width: "calc(100% - 16px)",
								overflow: "hidden",
								display: "-webkit-box",
								WebkitLineClamp: 2,
								WebkitBoxOrient: "vertical",
							}}
						>
							{thread.text.split(".")[0].replace(/�/g, "")}
						</Typography>
					</a>
				</Stack>
				<Stack direction="row" spacing={1} sx={{ paddingLeft: 0, color: theme.palette.text.secondary }}>
					<MetricStatus type={"view"} value={thread.views} />
					<MetricStatus type={"like"} value={thread.likes} />
					<MetricStatus type={"reply"} value={thread.replies} />
					<MetricStatus type={"repost"} value={thread.reposts} />
				</Stack>
			</Box>
		</CardContainer>
	);
};
